module.exports = __webpack_public_path__ + "img/source_mg-02.a851e881.png";